// extracted by mini-css-extract-plugin
export var brand = "_6t-8";
export var compact = "_6t-5";
export var extraSmall = "_6t-6";
export var icon = "_6t-0";
export var large = "_6t-3";
export var light = "_6t-1";
export var medium = "_6t-4";
export var outline = "_6t-a";
export var primaryDark = "_6t-9";
export var primaryLight = "_6t-7";
export var primaryModern = "_6t-b";
export var success = "_6t-2";